/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HistogramValues } from './HistogramValues';
import {
    HistogramValuesFromJSON,
    HistogramValuesFromJSONTyped,
    HistogramValuesToJSON,
} from './HistogramValues';

/**
 * 
 * @export
 * @interface SingleHistogramSeriesView
 */
export interface SingleHistogramSeriesView {
    /**
     * 
     * @type {string}
     * @memberof SingleHistogramSeriesView
     */
    customId: string;
    /**
     * 
     * @type {Array<HistogramValues>}
     * @memberof SingleHistogramSeriesView
     */
    values: Array<HistogramValues>;
}

/**
 * Check if a given object implements the SingleHistogramSeriesView interface.
 */
export function instanceOfSingleHistogramSeriesView(value: object): value is SingleHistogramSeriesView {
    if (!('customId' in value) || value['customId'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function SingleHistogramSeriesViewFromJSON(json: any): SingleHistogramSeriesView {
    return SingleHistogramSeriesViewFromJSONTyped(json, false);
}

export function SingleHistogramSeriesViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleHistogramSeriesView {
    if (json == null) {
        return json;
    }
    return {
        
        'customId': json['customId'],
        'values': ((json['values'] as Array<any>).map(HistogramValuesFromJSON)),
    };
}

export function SingleHistogramSeriesViewToJSON(value?: SingleHistogramSeriesView | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'customId': value['customId'],
        'values': ((value['values'] as Array<any>).map(HistogramValuesToJSON)),
    };
}

